/**
 * Shell chrome the app root binds into `libs/shared/ui`'s sidebar layout — the logo and the
 * imprint link. Relocated out of `custom-preset.ts`, which owns PrimeNG design tokens and has
 * no business holding template data.
 *
 * `logoSrc` is root-absolute on purpose: the shell renders on deep routes such as
 * `/discover/sites/:id`, where a relative `assets/…` would resolve against the route segment.
 *
 * `impressum` is still an unresolved placeholder. It predates this slice — pointing it at the
 * real imprint is a separate change, tracked as follow-up in the theme plan.
 */
export const links = {
  logoSrc: '/assets/images/logo.svg',
  logoAlt: 'AIVille',
  impressum: '#',
};
